// Handling AI summaries
import { initSummaryEventsUniversal } from '../../../files/file-list.dom/summary-events-universal.js';

/**
 * Lazy fetch and render summaries from IndexedDB
 */
export function lazyFetchSummaries(linkKeys, nameKeys) {
    try {
        const currentQuery = window.QUERY;
        const $container = $('#nav-full-text');
        
        const applyByKeys = (keysArr, valuesArr) => {
            if (currentQuery !== window.QUERY) return;
            valuesArr.forEach((val, i) => {
                if (!val) return;
                const k = keysArr[i];
                let block = $container.find(`.fulltext-summary[data-summary-for="${k}"]`).first();
                if (!block.length) {
                    block = $container.find(`.fulltext-summary[data-name-key="${k}"]`).first();
                }
                if (!block.length) return;
                const textEl = block.find('.fulltext-summary__text');
                textEl.text(String(val).trim());
                const card = block.closest('.search-result-item');
                const chip = card.find('.fulltext-summary__chip');
                if (chip.length) chip.removeClass('d-none');
            });
        };

        const run = () => {
            if (window.filesCacheManager && typeof window.filesCacheManager.getSummariesByKeys === 'function') {
                window.filesCacheManager.getSummariesByKeys(linkKeys).then((vals) => {
                    const hasAny = Array.isArray(vals) && vals.some(v => typeof v !== 'undefined');
                    if (hasAny) { applyByKeys(linkKeys, vals); return; }
                    window.filesCacheManager.getSummariesByKeys(nameKeys).then((vals2) => applyByKeys(nameKeys, vals2)).catch(() => {});
                }).catch(() => {
                    window.filesCacheManager.getSummariesByKeys(nameKeys).then((vals2) => applyByKeys(nameKeys, vals2)).catch(() => {});
                });
            }
        };

        if (typeof window.requestIdleCallback === 'function') { 
            window.requestIdleCallback(run, { timeout: 800 }); 
        } else { 
            setTimeout(run, 0); 
        }
    } catch(_) {}
}

/**
 * Initialize summary events
 */
export function initSummaryEvents() {
    try {
        initSummaryEventsUniversal({
            container: $(document),
            chipSelector: '.fulltext-summary__chip',
            getFileData: (element) => {
                const $chip = $(element);
                const $card = $chip.closest('.search-result-item');
                if (!$card.length) return null;
                
                const isFulltextCard = $card.hasClass('fulltext-result-card');
                const isInFulltext = $card.closest('#nav-full-text').length > 0 || isFulltextCard;
                if (!isInFulltext) return null;
                
                const linkKey = $card.attr('data-key') || '';
                const $summaryBlock = $card.find('.fulltext-summary');
                const nameKey = $summaryBlock.attr('data-name-key') || '';
                
                const fileName = $card.attr('data-name') || nameKey || linkKey.split('/').pop() || 'Unknown';
                const filePath = $card.attr('data-path') || linkKey || '';
                const fileKey = linkKey || nameKey;
                
                return {
                    file: { n: fileName, name: fileName, p: filePath, path: filePath },
                    fileKey: fileKey,
                    nameKey: nameKey
                };
            },
            mobileClickOnly: true
        });
    } catch(err) { 
        console.error('[Fulltext Search] ❌ Error setting up summary events:', err);
    }
}
